import { IconButton, LinearProgress, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { ConfirmDialog } from "./ConfirmDialog";
import { useRef } from "react";
import { MyListApi } from "../utils/restApi";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const FriendsList = ({ friends }) => {

    const ref = useRef();
    const user = useSelector(state => state.login.user);
    const dispatch = useDispatch();

    const handleConfirmAcceptFriend = (friendId) => {
        ref.current.openConfirm(() => {
            MyListApi.acceptFriendRequest(friendId)
                .then(_ => {

                })
                .catch(error => {
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        });
    }

    if (!user) {
        return <LinearProgress />;
    }

    return (
        <div>
            <ConfirmDialog title="Accept Friend Request" message="Accept friend request?" ref={ref} />
            <TableContainer component="div">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {friends.map(row => {
                            const requested = row.friendUser.id == user.id;
                            let name = requested ? row.user.name : row.friendUser.name;
                            let status = requested ? 'awaiting approval' : row.status;
                            return (
                                <TableRow key={row.id}>
                                    <TableCell>
                                        <Link href={`/user/${row.friendUser.id}/items`} underline="hover">{`@${name}`}</Link>
                                    </TableCell>
                                    <TableCell>
                                        {status}
                                    </TableCell>
                                    <TableCell>
                                        {requested ?
                                            <Tooltip title="Accept Friend Request" arrow>
                                                <IconButton color="primary" onClick={() => handleConfirmAcceptFriend(row.id)}><PersonAddIcon /></IconButton>
                                            </Tooltip>
                                        : undefined}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}